import React, { useState, useContext, useEffect, useLayoutEffect, useRef } from 'react';
import StudentNav from '../Navbars/StudentNav';
import AdminNav from '../Navbars/AdminNav';
import TeacherNav from '../Navbars/TeacherNav';
import GuestNav from '../Navbars/GuestNav';
import Footer from '../Footer';
import { useParams } from 'react-router-dom';
import './CreateCertificate.css';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import axios from 'axios';

import jsPDF from 'jspdf';
import { PDFDownloadLink } from "@react-pdf/renderer";
import { usePDF, Resolution, Margin } from 'react-to-pdf';

import PDF from './PDF';
import Signature from "./PDF_Images/signature.png";

import LebronStretch from "./PDF_Images/Image1.jpeg";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const CreateCertificate = () => {
  const { courseId, coursename } = useParams();
  // const [courseName, setCourseName] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedStudentDetails, setSelectedStudentDetails] = useState(null);
  const [certificateNumber, setCertificateNumber] = useState('')
  const [courses, setCourses] = useState([])
  const [selectedCourse, setSelectedCourse] = useState({ courseId: '', coursename: '' })
  const [refresh, setRefresh] = useState(false)
  const [textAreaValue, setTextAreaValue] = useState('')
  const [certificateType, setCertificateType] = useState(1)

  function getDate() {
    const now = new Date();
    const date = now.getDate();
    const monthName = now.toLocaleString('en-US', { month: 'short' });
    const year = now.getFullYear();
    return `${date}-${monthName}-${year}`;
  }
  const [currentDate, setCurrentDate] = useState(getDate());

  useEffect(() => {
    fetchStudents();
  }, [refresh]);
  const fetchCertificatNumber = async (studentId, coursename) => {
    // Only fetch if both studentId and coursename are provided
    if (!studentId || !coursename) {
      console.log('⚠️ Student ID or Course name missing, skipping certificate number generation');
      console.log('StudentId:', studentId, 'Coursename:', coursename);
      return;
    }

    try {
      console.log('🔄 Fetching certificate number for:', { studentId, coursename });
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateCertificateNumber`, {
        params: {
          studentId: studentId,
          coursename: coursename
        }
      });

      const certNum = response?.data?.certificateNumber;
      console.log('✅ Generated Certificate Number:', certNum);

      if (!certNum) {
        console.error('❌ Certificate number is empty in response:', response?.data);
      }

      setCertificateNumber(certNum);
    } catch (error) {
      console.error('❌ Error generating certificate number:', error);
      console.error('Error details:', error.response?.data || error.message);
    }
  }
  const fetchCourseName = async () => {
    try {
      // const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/PDFCertificate_coursename/${courseId}`);
      // setCourseName(response.data.coursename);
    } catch (error) {
      console.error('Error fetching course name:', error);
    }
  };
  const fetchStudents = async () => {
    // if (courseId) {
    try {
      // const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/students_by_course/${courseId}`);
      const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/student`);

      setStudents(response.data);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
    // } else {
    //   setStudents([]);
    // }
  };


  // Reset form function
  const resetForm = () => {
    setSelectedStudentDetails(null);
    setSelectedCourse({ courseId: '', coursename: '', StartDate: '', EndDate: '' });
    setCourses([]);
    setCertificateNumber('');
    setTextAreaValue('');
    setCertificateType(1);
  };

  // Handle student selection
  const handleStudentChange = async (event) => {
    const studentId = event.target.value;
    if (!studentId) {
      setSelectedStudentDetails(null);
      setCourses([]);
      return;
    }

    const selectedStudent = students.find(student => student.User_id.toString() === studentId);
    if (!selectedStudent) return;

    axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getCertificateCourses/${selectedStudent.Student_id}`).then((res) => {
      console.log("courses Data :", res.data.courses)
      setCourses(res.data.courses)
    })
    setSelectedCourse({ courseId: '', coursename: '', StartDate: '', EndDate: '' })
    setCertificateNumber(''); // Reset certificate number when student changes

    setSelectedStudentDetails({
      userId: selectedStudent.User_id,
      firstname: selectedStudent.firstname,
      lastname: selectedStudent.lastname,
      parentname: selectedStudent.parentname,
    });
  };

  // const generateCertificate = () => {
  //   // Initialize jsPDF
  //   const doc = new jsPDF();

  //   // Add image to the PDF (adjust coordinates and size as needed)
  //   const img = new Image();
  //   img.src = 'Image1.jpeg';
  //   doc.addImage(img, 'JPEG', 15, 40, 180, 120);


  //   doc.setFontSize(22);
  //   doc.text(20, 20, `Certificate for ${courseName}`);

  //   // Save the PDF file with course name as filename
  //   doc.save(`${courseName}_certificate.pdf`);
  // };

  const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  useLayoutEffect(() => {
    const fetchData = async () => {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: 'include',
      }).then(response => {
        //  console.log("Response:",response);
        response.json().then(userInfo => {
          //  console.log("userinfo:",userInfo);
          setUserInfo(userInfo);
          if (userInfo?.usertype) {
            const uType = userInfo?.usertype;
            setUserRole(uType);
          }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable
          //  console.log("Uname Admin Register", uname);
          //  console.log("Avatar in: ", avatar);

        })
          .catch(err => console.log("Error in useeffect:", err))
      });
    }
    fetchData();
  }, [isAdmin, isTeacher, isStudent, isGuest]);

  const onLogin = (usertype) => {

    setUserRole(usertype);
  };
  const navigate = useNavigate();

  async function onLogout() {
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: 'include',
      method: 'POST',
    });
    setUserInfo(null);
    console.log("navigating");
    navigate('/');
    // console.log("navigated");
    setUserRole('guest');
  }
  const options = {
    method: 'open',

    page: {
      format: 'A2',
      orientation: 'landscape',
    }
  }
  const username = userInfo?.username;
  const _avatar_ = userInfo?.avatar;
  const { toPDF, targetRef } = usePDF({
    filename: `certificate-${selectedStudentDetails?.firstname + ' ' + selectedStudentDetails?.lastname || ''}-${certificateNumber}.pdf`,
    // paperSize: [1600, 1234],
    // format: '1600x1234',
    paperSize: [1234, 1600], // Explicitly set width < height for landscape
    format: 'landscape',    // Check if the library supports an orientation property
    page: { margin: Margin.NONE, orientation: "landscape" },
    resolution: Resolution.LOW

  });
  async function generateCertificatePdf() {
    // Validation: Check if certificate number is generated
    if (!certificateNumber || certificateNumber === '') {
      alert('Please select both student and course to generate certificate number first!');
      console.error('Certificate number is missing');
      return;
    }

    // Validation: Check if student is selected
    if (!selectedStudentDetails) {
      alert('Please select a student first!');
      return;
    }

    try {
      const pdf = await toPDF();
      const pdfBlob = pdf.output('blob');
      const formDataInvoice = new FormData();

      const data = {
        courseId: selectedCourse?.courseId || null,
        coursename: selectedCourse?.coursename,
        User_id: selectedStudentDetails?.userId,
        name: selectedStudentDetails?.firstname,
        date: new Date(),
        certificateNumber
      }

      console.log('Sending certificate data:', data);

      // Append timestamp to ensure unique filename and bypass browser caching
      formDataInvoice.append('pdfFile', pdfBlob, `Certificate-${selectedStudentDetails?.firstname} ${selectedStudentDetails?.lastname}-${certificateNumber}-${Date.now()}.pdf`);
      formDataInvoice.append('data', JSON.stringify(data));

      const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateCertificate`, formDataInvoice, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });

      // alert('Certificate generated successfully!');
      // setShowToast(true);
      // setTimeout(() => setShowToast(false), 3000);
      toast.success('Certificate Generated Successfully!', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Reset form after successful generation
      resetForm();
      setRefresh(!refresh);
    } catch (error) {
      console.error('Error generating certificate:', error);
      alert('Error generating certificate: ' + (error.response?.data?.message || error.message));
    }
    // }
    // else{
    //   const response = await axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/generateEventCertificate`, formDataInvoice, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data',
    //     }
    //   }).then(() => {
    //     setStudents([])
    //     setSelectedStudentDetails(null)
    //     setCourses([])
    //     setRefresh(!refresh)
    //     setCertificateNumber(Math.floor(100000 + Math.random() * 900000))
    //   })
    // }

  }
  function getDate() {
    // const today = new Date();
    // const month = today.getMonth() ;
    // const year = today.getFullYear();
    // const date = today.getDate();
    const now = new Date();
    const date = now.getDate();

    const monthName = now.toLocaleString('en-US', { month: 'short' });
    const year = now.getFullYear();
    return `${date}-${monthName}-${year}`;
    // return today.toDateString().slice(0, 10)
  }
  // function formatDate(dateStr){
  //   const date = new Date(dateStr);
  //   const day = date.getDate().toString().padStart(2, '0');
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };
  function formatDate(dateString) {
    const date = new Date(dateString);

    // Get day with ordinal suffix (1st, 2nd, 3rd, 4th, etc.)
    const day = date.getDate();
    // const ordinalSuffix = getOrdinalSuffix(day);

    // Get month name
    const monthNames = [
      "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
      "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
    ];
    const month = monthNames[date.getMonth()];

    // Get year
    const year = date.getFullYear();

    // Combine all parts
    return `${day} ${month} ${year}`;
  }
  function chageCertificateType(e) {
    setCertificateType(e.target.value)
    if (e.target.value == 1) {
      // Course Certificate - requires course selection
      if (selectedCourse && selectedCourse.coursename) {
        setTextAreaValue(`For the exceptional performance that has led to the successful completion of Polymath-Kids ${selectedCourse.coursename}  conducted between ${formatDate(selectedCourse.StartDate)} and ${formatDate(selectedCourse.EndDate)}`)
      } else {
        setTextAreaValue('')
      }
    }
    else if (e.target.value == 2) {
      // Winning Certificate - Event based
      const eventName = 'PolyMatch 2024';
      setTextAreaValue(`Winner of Junior Level Islamic Knowledge Competition - PolyMatch 2024`)

      // Generate certificate number for event
      if (selectedStudentDetails?.userId) {
        fetchCertificatNumber(selectedStudentDetails.userId, eventName);
      }
    }
    else if (e.target.value == 3) {
      // Participation Certificate - Event based
      const eventName = 'PolyMatch 2024';
      setTextAreaValue(`Participation in Junior Level Islamic Knowledge Competition - PolyMatch 2024`)

      // Generate certificate number for event
      if (selectedStudentDetails?.userId) {
        fetchCertificatNumber(selectedStudentDetails.userId, eventName);
      }
    }
  }
  function handleCourseChange(e) {
    const courseId = parseInt(e.target.value);
    const selectedCourseData = courses.find(c => c.Course_id === courseId);

    if (selectedCourseData) {
      console.log("Selected Course:", selectedCourseData.coursename);

      setSelectedCourse({
        courseId: selectedCourseData.Course_id,
        coursename: selectedCourseData.coursename,
        StartDate: selectedCourseData.StartDate,
        EndDate: selectedCourseData.EndDate
      });

      setTextAreaValue(`For the exceptional performance that has led to the successful completion of Polymath-Kids ${selectedCourseData.coursename}  conducted between ${formatDate(selectedCourseData.StartDate)} and ${formatDate(selectedCourseData.EndDate)}`);

      // Generate certificate number when course is selected
      if (selectedStudentDetails?.userId) {
        fetchCertificatNumber(selectedStudentDetails.userId, selectedCourseData.coursename);
      }
    } else {
      setSelectedCourse({ courseId: '', coursename: '', StartDate: '', EndDate: '' });
      setTextAreaValue('');
      setCertificateNumber(''); // Reset certificate number
    }
  }
  // function formatDate(dateString) {
  //   const date = new Date(dateString);

  //   // Get day with ordinal suffix (1st, 2nd, 3rd, 4th, etc.)
  //   const day = date.getDate();
  //   const ordinalSuffix = getOrdinalSuffix(day);

  //   // Get month name
  //   const monthNames = [
  //       "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
  //       "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
  //   ];
  //   const month = monthNames[date.getMonth()];

  //   // Get year
  //   const year = date.getFullYear();

  //   // Combine all parts
  //   return `${day}${ordinalSuffix} ${month} ${year}`;
  // }
  // function formatDate(dateStr){
  //   const date = new Date(dateStr);
  //   const day = date.getDate().toString().padStart(2, '0');
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //   const year = date.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  return (
    <>

      {username && (
        <>
          {isAdmin && <AdminNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isTeacher && <TeacherNav username={username} avatar={_avatar_} onLogout={onLogout} />}
          {isStudent && <StudentNav username={username} avatar={_avatar_} onLogout={onLogout} />}
        </>
      )}
      {!username && (
        <>
          {isGuest && <GuestNav onLogin={onLogin} />}
        </>
      )}

      <div className='edit-bar'>
        <h3 className='HeadingPDFcert'>
          Generate Certificate
        </h3>
        <br />
        <h2 className='coursenamePDFcert'>
          {selectedCourse.coursename || 'Select a course to begin'}
        </h2>
      </div>



      {/* Form always visible */}
      <div className='StudentDetails'>
        <h3>Certificate Details</h3>
        <table className='StudentTable'>
          <tbody>
            <tr>
              <th>Select Student</th>
              <td>
                <select
                  id='TPcourseDropdown'
                  onChange={handleStudentChange}
                  style={{ width: '100%', padding: '8px' }}
                  value={selectedStudentDetails?.userId || ''}
                >
                  <option value=''>Select Student</option>
                  {students.map((student) => (
                    <option key={student.User_id} value={student.User_id}>
                      {student.firstname} {student.lastname}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>First Name</th>
              <td>{selectedStudentDetails?.firstname?.toUpperCase() || '-'}</td>
            </tr>
            <tr>
              <th>Last Name</th>
              <td>{selectedStudentDetails?.lastname?.toUpperCase() || '-'}</td>
            </tr>
            <tr>
              <th>Parent Name</th>
              <td>{selectedStudentDetails?.parentname || '-'}</td>
            </tr>
            <tr>
              <th>Certificate Type</th>
              <td>
                <select value={certificateType} onChange={chageCertificateType}>
                  <option value={1}>
                    Course Certificate
                  </option>
                  <option value={3}>
                    Participation Certificate
                  </option>
                  <option value={2}>
                    Winning Certificate
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th>Select Course</th>
              <td>
                <select id='courseDropdown' onChange={handleCourseChange} value={selectedCourse.courseId || ''}>
                  <option value="">Select Course</option>
                  {
                    courses.map((course) => (
                      <option key={course.Course_id} value={course.Course_id}>{course.coursename}</option>
                    ))
                  }
                </select>
              </td>
            </tr>
            <tr>
              <th>{certificateType == 1 ? 'Certificate Text' : 'Event Name'}</th>
              <td>
                <textarea
                  rows={5}
                  style={{ width: "100%" }}
                  value={textAreaValue}
                  placeholder={certificateType == 1 ? '' : 'Enter Event Name'}
                  onChange={(e) => setTextAreaValue(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>


      </div>

      <div className='GenSalary'>
        {/* <button className='SalaryBtn' onClick={generateCertificate} >Generate Salary</button> */}
        {/* <PDFDownloadLink document={<PDF
              selectedStudentDetails={selectedStudentDetails}
              courseId
            />} filename="FORM" >
                {({loading}) => (loading ? <button>Loading Document...</button> : <button className='SalaryBtn'>Download Certificate</button> )}
            </PDFDownloadLink> */}
        <button onClick={() => generateCertificatePdf()}>Download Certificate </button>
      </div>

      {/* Certificate Preview - Visible for real-time editing */}
      <div style={{ padding: "3%", marginTop: "10px" }}>
        {selectedStudentDetails && (<div style={{ width: "1600px", height: "1120px", position: "relative" }} ref={targetRef}>
          <img src={LebronStretch} style={{ height: "100%", width: "100%", objectFit: "cover" }} />

          <div style={{ position: "absolute", top: "2.25%", right: "15%", width: "400px", textAlign: "right", fontWeight: "bold", fontSize: "15px", color: "purple", lineHeight: "1.1", whiteSpace: "normal", overflowWrap: "break-word", wordWrap: "break-word" }}>
            {certificateNumber || '___________'}
          </div>

          <div style={{ position: "absolute", top: "40%", textAlign: "center", width: "100%", fontSize: "40px", color: "white", fontWeight: "bold" }}>
            {selectedStudentDetails.firstname.toUpperCase()} {selectedStudentDetails.lastname.toUpperCase()}
          </div>
          <div style={{ position: "absolute", top: "51%", padding: "0 15%", textAlign: "center", width: "100%", fontSize: "30px", color: "purple", fontWeight: "500" }}>
            {certificateType == 1 ? <> S/O, D/O <b>{selectedStudentDetails?.parentname}</b> {textAreaValue}</> : <>{textAreaValue}</>}

          </div>

          <div style={{ position: "absolute", top: "81%", left: "62%", fontWeight: "500", fontSize: "28px", color: "purple" }}>
            {currentDate}
          </div>
          <img src={Signature} style={{ height: "125px", width: "180px", position: "absolute", top: "77%", left: "27%" }} />


          {/* </div> */}
        </div>)}
      </div>
      <Footer />
      <ToastContainer />

    </>
  );
}

export default CreateCertificate;
